export const GET_DETAIL_PHIEU_THUCHI = "GET_DETAIL_PHIEU_THUCHI";
export const GET_DETAIL_PHIEU_THUCHI_SUCCESS =
  "GET_DETAIL_PHIEU_THUCHI_SUCCESS";
export const GET_DETAIL_PHIEU_THUCHI_FAILURE =
  "GET_DETAIL_PHIEU_THUCHI_FAILURE";

export const GET_IN_PHIEU_THUCHI = "GET_IN_PHIEU_THUCHI";
export const GET_IN_PHIEU_THUCHI_SUCCESS = "GET_IN_PHIEU_THUCHI_SUCCESS";
export const GET_IN_PHIEU_THUCHI_FAILURE = "GET_IN_PHIEU_THUCHI_FAILURE";
export const SHOW_IN_PHIEU_THUCHI = "SHOW_IN_PHIEU_THUCHI";
